import moment from 'moment'
import { utils } from 'gipsy-misc'

export const shouldRescheduleOverload = (totalDuration, dailyWorkingHours) => {
  if (!dailyWorkingHours.active || totalDuration <= 0) {
    return false
  }
  const now = moment()
  const workStart = dailyWorkingHours.workStart
  const workEnd = dailyWorkingHours.workEnd
  const startOfWorkingDay = moment()
    .hour(workStart.hour)
    .minute(workStart.minute)
    .seconds(0)
  const endOfWorkingDay = moment()
    .hour(workEnd.hour)
    .minute(workEnd.minute)
    .seconds(0)

  const startOfDay = startOfWorkingDay.diff(now, 'seconds') > 0 ? startOfWorkingDay : now

  const secondsRemainingBeforeEndOfDay = endOfWorkingDay.diff(startOfDay, 'seconds')

  const totalDurationSeconds = totalDuration / utils.datetime.estimatedTimeUnitsBySecond

  return totalDurationSeconds >= secondsRemainingBeforeEndOfDay
}

export const moveElementInItemsfromPositionToPosition = (element, items, from, to) => {
  /* create a copy of to avoid mutate it */
  items = Object.assign({}, items)
  /*
   ** remove element from group "fromGroup" at index "fromIndex"
   ** when the element is created, from is null, we just want to insert it after with splice
   */
  if (from) {
    /* create a copy of array list to force rerender on changes */
    items[from.group].list = [].concat(items[from.group].list)
    items[from.group].list.splice(from.index, 1)
  }

  /* insert element in table "toGroup" at index "toIndex" */
  if (element && to) {
    items[to.group].list = [].concat(items[to.group].list)
    items[to.group].list.splice(to.index, 0, element)
  }

  return items
}

/* 
  expect params to be a formatted date string YYYY-MM-DD, 
  but also accept random string (if "updates" will be first otherwise will be last) 
*/
export const compareArchiveGroups = (groupAStr, groupBStr) => {
  if (groupAStr === 'updates') {
    return -1
  }
  if (groupBStr === 'updates') {
    return 1
  }
  return utils.datetime.compareDates(groupAStr, groupBStr)
}



// WEBPACK FOOTER //
// ./src/features/todolist/utils.js